import { forwardRef } from 'react';

import { RefReturnType, RegisterType } from '../../types/CommonTypes';
import { TextareaStyle } from './Textarea.styles';

type TextareaProps = React.DetailedHTMLProps<
  React.TextareaHTMLAttributes<HTMLTextAreaElement>,
  HTMLTextAreaElement
> & {
  className?: string;
  defaultValue?: string;
  disabled?: boolean;
  name?: string;
  onChange?: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
  placeholder?: string;
  textareaMaxLength?: string;
  register?: ({ maxLength, required }: RegisterType) => RefReturnType;
  value?: string;
};

const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  (
    {
      className,
      defaultValue,
      disabled = false,
      maxLength,
      name = '',
      onChange,
      placeholder,
      register,
      required,
      textareaMaxLength,
      value,
    }: TextareaProps,
    ref
  ): JSX.Element => {
    return (
      <TextareaStyle
        className={className}
        defaultValue={defaultValue}
        disabled={disabled}
        id={name}
        maxLength={textareaMaxLength}
        name={name}
        onChange={onChange}
        placeholder={placeholder}
        ref={
          register
            ? register({
                maxLength,
                required,
              })
            : ref
        }
        value={value || ''}
      />
    );
  }
);

Textarea.displayName = 'Textarea';

export default Textarea;
